// extracted by mini-css-extract-plugin
export default {"flexWithIcon":"FlexItem_flexWithIcon__gp9JJ","columnFlex":"FlexItem_columnFlex__K3fzp"};